export enum HeaderType {
  Basic,
  LCLBooking,
  LCLShipment,
  ESNotes,
  ISFNotes,
  ISFList,
  ESList,
  MarineInsuranceView,
}
